<div class="container-fluid">
  <div class="page-head">
    <h5 class="header-title text-primary pl-2 pl-md-1">
      ONLINE CONSULTATION APPOINTMENT REQUEST
    </h5>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <form [formGroup]="findAppointmentForm">
            <div class="row">
              <div class="col-12">
                <p class="text-center font-size-15 font-weight-400">
                  ENTER PHYSICIAN NAME OR APPOINTMENT DATE
                </p>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="dp-hidden position-absolute">
                <div class="input-group">

                  <!-- <input name="datepicker" ngbDatepicker #datepicker="ngbDatepicker"
                      (dateSelect)="onDateSelection($event)" [matDatepicker]="picker"> -->
                  <input name="datepicker" class="form-control" ngbDatepicker #datepicker="ngbDatepicker"
                    class="calendar1" [autoClose]="'outside'" (dateSelect)="onDateSelection($event, datepicker)"
                    [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden" tabindex="-1"
                    style="border:1px solid white !important;" />
                  <ng-template #t let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                      [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                      (mouseleave)="hoveredDate = null">
                      {{ date.day }}
                    </span>
                  </ng-template>
                </div>
              </div>
              <div class="col-lg-2"></div>
              <div class="col-lg-3 col-md-3">
                <input type="text" class="form-control" placeholder="Physician Name" name="physicianName"
                  formControlName="physicianName" />
              </div>

              <!-- <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <input type="text" class="form-control select" placeholder="Patient Name" name="patName"
                  formControlName="patName" />
              </div> -->

              <!-- <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <div class="d-flex">
                  <input class="form-control" placeholder="Date of Appointment (DD/MM/YYYY)" name="appointmentDate"
                    ngbDatepicker #appointment="ngbDatepicker" data-date-inline-picker="false" id="appointmentDate"
                    formControlName="apDate" />
                  <div>
                    <button class="btn btn-outline-secondary button-height calendar rounded-0"
                      (click)="appointment.toggle()" type="button" id="AppointmentButton">
                      <span class="fa fa-calendar"></span>
                    </button>
                  </div>
                </div>
                <div *ngIf="findAppointmentForm.get('apDate').hasError('ngbDate')" class="invalid-feedback"> Appointment
                  Date
                  is invalid
                </div>
              </div> -->
              <!-- <div class="row"> -->

              <div class="col d-flex">
                <input class="form-control" placeholder="fromDate" name="findAppointmentForm['fromDate']"
                  [value]="formatter.format(fromDate)"
                  (input)="fromDate = validateInput(fromDate, findAppointmentForm['fromDate'].value)" />
                <button class="btn btn-outline-secondary button-height calendar rounded-0" (click)="datepicker.toggle()"
                  type="button"><span class="fa fa-calendar"></span></button>
                <!-- <input class="form-control" placeholder="From Date(DD/MM/YYYY)" name="fromDate" ngbDatepicker
                  #fromDate="ngbDatepicker" data-date-inline-picker="true" id="fromDate" formControlName="fromDate" />
                <div class="input-group-append">
                  <button class="input-group-text btn btn-outline-secondary button-height calendar rounded-0"
                    (click)="fromDate.toggle()" type="button" id="fromDate">
                    <span class="fa fa-calendar"></span>
                  </button>
                </div> -->
              </div>

              <div class="col d-flex ml-2">
                <input class="form-control" placeholder="To Date" name="appointment['toDate']"
                  [value]="formatter.format(toDate)"
                  (input)="toDate = validateInput(toDate, findAppointmentForm['toDate'].value)" />
                <button class="btn btn-outline-secondary button-height calendar rounded-0" (click)="datepicker.toggle()"
                  type="button"><span class="fa fa-calendar"></span></button>

                <!-- <input class="form-control" placeholder="To Date(DD/MM/YYYY)" name="toDate" ngbDatepicker
                  #toDate="ngbDatepicker" data-date-inline-picker="true" id="toDate" [minDate]="minDate"
                  formControlName="toDate" />
                <div class="input-group-append">
                  <button class="input-group-text btn btn-outline-secondary button-height calendar rounded-0"
                    (click)="toDate.toggle()" type="button" id="toDate">
                    <span class="fa fa-calendar"></span>
                  </button>
                </div> -->
              </div>

              <!-- <div class="col-lg-3 col-md-3"></div> -->
              <!-- </div> -->
              <div class="col-lg-1"></div>
            </div>
            <br /><br />
            <div class="row">
              <div class="col-12 text-center">
                <button type="submit" name="find" class="btn btn-primary text-white" (click)="findAppointments()"
                  [disabled]="invalidForm">
                  FIND APPOINTMENT
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="container-fluid" *ngIf="Appointments?.length || isFilterActive">
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body table-responsive">
          <div class="row">
            <div class="col-lg-12">
              <button type="submit" name="find" (click)="findAppointments()"
                [ngClass]="{ 'btn-primary': !activeFilter }"
                class="btn button-color btn-rounded text-white button-padding mr-4 mt-md-1 mt-2">
                ALL
              </button>
              <button type="submit" name="find" (click)="findAppointments(AppointmentRequestType.NEW)"
                class="btn button-color btn-rounded text-white btn-rounded mr-4 mt-md-1 mt-2" [ngClass]="{
                  'btn-primary': activeFilter === AppointmentRequestType.NEW
                }">
                <img src="/assets/images/Vector.png" class="mr-2" />NEW
              </button>
              <button type="submit" name="find" [ngClass]="{
                  'btn-primary':
                    activeFilter === AppointmentRequestType.RESCHEDULE
                }" (click)="findAppointments(AppointmentRequestType.RESCHEDULE)"
                class="btn button-color text-white btn-rounded mr-4 mt-md-1 mt-2">
                <img src="/assets/images/addBell.png" class="mr-2" />RESCHEDULED
              </button>
              <button type="submit" name="find" [ngClass]="{
                  'btn-primary':
                    activeFilter === AppointmentRequestType.CANCELLED
                }" (click)="findAppointments(AppointmentRequestType.CANCELLED)"
                class="btn button-color text-white btn-rounded mt-md-1 mt-2">
                <i class="fa fa-bell-slash-o mr-2"></i>CANCELLED
              </button>
            </div>
          </div>
          <div class="row" *ngIf="Appointments?.length">
            <div class="col-md-12 mt-3 detail-tbl">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">APPOINTMENT TYPE</th>
                    <th scope="col">DATE</th>
                    <th scope="col">TIME</th>
                    <th scope="col">PATIENT NAME</th>
                    <th scope="col">CONSULTING DOCTOR</th>
                    <th scope="col">ACTION</th>
                  </tr>
                </thead>
                <tr *ngFor="let appointment of Appointments">
                  <td class="font-size-15" *ngIf="appointment?.patient_first_name">
                    <img src="/assets/images/bell-blue.png" class="ml-5" *ngIf="
                        !appointment?.request_type ||
                        appointment?.request_type ===
                          AppointmentRequestType?.NEW
                      " />
                    <img src="/assets/images/add-blue-bell.png" class="ml-5" *ngIf="
                        appointment?.request_type ===
                        AppointmentRequestType?.RESCHEDULE
                      " />
                    <img src="/assets/images/slash-bell.png" class="ml-5" *ngIf="
                        appointment?.request_type ===
                        AppointmentRequestType?.CANCELLED
                      " />
                  </td>
                  <td class="font-size-15 text-color" *ngIf="appointment?.patient_first_name">
                    {{ appointment?.apdate | date: dateFormat }}
                  </td>
                  <td class="font-size-15 text-color" *ngIf="appointment?.patient_first_name">
                    {{ appointment?.aptime }}
                  </td>
                  <td class="font-size-15 text-color" *ngIf="appointment?.patient_first_name">
                    {{ appointment?.patient_first_name }}
                    {{ appointment?.patient_last_name }}
                  </td>
                  <td class="font-size-15 text-color" *ngIf="appointment?.patient_first_name">
                    {{ appointment?.physician_first_name }}
                    {{ appointment?.physician_last_name }}
                  </td>
                  <td class="check" *ngIf="appointment?.patient_first_name">
                    <div class="d-flex">
                      <div class="tabledit-toolbar btn-toolbar"
                        *ngIf="appointment?.request_type !== AppointmentRequestType?.CANCELLED">
                        <div class="btn-group btn-group-sm">
                          <button type="button" (click)="editRequest(appointment)"
                            class="tabledit-edit-button btn btn-sm btn-info mr-2 edit">
                            <span class="ti-pencil"></span>
                          </button>
                        </div>
                      </div>
                      <div class="tabledit-toolbar btn-toolbar">
                        <div class="btn-group btn-group-sm">
                          <button type="button" (click)="checkRequest(appointment)"
                            class="tabledit-edit-button btn btn-sm btn-success mr-2">
                            <span class="ti-check"></span>
                          </button>
                        </div>
                      </div>
                      <div class="tabledit-toolbar btn-toolbar"
                        *ngIf="appointment?.request_type !== AppointmentRequestType?.CANCELLED">
                        <div class="btn-group btn-group-sm">
                          <button type="button" (click)="closeRequest(appointment)"
                            class="tabledit-edit-button btn btn-sm btn-danger mr-2">
                            <span class="ti-close"></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tbody>
                  <tr></tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row" *ngIf="Appointments?.length">
            <div class="col-md-12 mt-2">
              <div class="d-flex">
                <div class="form-group d-flex mb-0 mr-2">
                  <select class="form-control" [(ngModel)]="pagesize" id="pagesize" (change)="pageChanged()">
                    <option *ngFor="let c of pageCount" value="{{ c }}">
                      {{ c }}
                    </option>
                  </select>
                </div>
                <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [maxSize]="5" [pageSize]="pagesize"
                  [rotate]="true" [boundaryLinks]="true" (pageChange)="pageChanged()"></ngb-pagination>
                <div class="ml-2 line-h-36">
                  Total rows : {{ collectionSize }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 
<div class="container-fluid" *ngIf="Appointments?.length || isFilterActive">
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body table-responsive">
          <div class="row">
            <div class="col-lg-12">
              <button type="submit" name="find" (click)="findAppointments()"
                [ngClass]="{ 'btn-primary': !activeFilter }"
                class="btn button-color btn-rounded text-white button-padding mr-4 mt-md-1 mt-2">
                ALL
              </button>
              <button type="submit" name="find" (click)="findAppointments(AppointmentRequestType.NEW)"
                class="btn button-color btn-rounded text-white btn-rounded mr-4 mt-md-1 mt-2" [ngClass]="{
                  'btn-primary': activeFilter === AppointmentRequestType.NEW
                }">
                <img src="/assets/images/Vector.png" class="mr-2" />NEW
              </button>
              <button type="submit" name="find" [ngClass]="{
                  'btn-primary':
                    activeFilter === AppointmentRequestType.RESCHEDULE
                }" (click)="findAppointments(AppointmentRequestType.RESCHEDULE)"
                class="btn button-color text-white btn-rounded mr-4 mt-md-1 mt-2">
                <img src="/assets/images/addBell.png" class="mr-2" />RESCHEDULED
              </button>
              <button type="submit" name="find" [ngClass]="{
                  'btn-primary':
                    activeFilter === AppointmentRequestType.CANCELLED
                }" (click)="findAppointments(AppointmentRequestType.CANCELLED)"
                class="btn button-color text-white btn-rounded mt-md-1 mt-2">
                <i class="fa fa-bell-slash-o mr-2"></i>CANCELLED
              </button>
            </div>
          </div>
          <div class="row" *ngIf="Appointments?.length">
            <div class="col-md-12 mt-5 detail-tbl">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">APPOINTMENT TYPE</th>
                    <th scope="col">DATE</th>
                    <th scope="col">TIME</th>
                    <th scope="col">PATIENT NAME</th>
                    <th scope="col">CONSULTING DOCTOR</th>
                    <th scope="col">ACTION</th>
                  </tr>
                </thead>
                <tr *ngFor="let appointment of Appointments">
                  <td class="font-size-15" *ngIf="appointment?.patient_first_name">
                    <img src="/assets/images/bell-blue.png" class="ml-5" *ngIf="
                        !appointment?.request_type ||
                        appointment?.schedule_stat ===
                          AppointmentRequestType?.APPROVAL_REQUESTED
                      " />
                    <img src="/assets/images/add-blue-bell.png" class="ml-5" *ngIf="
                        appointment?.request_type ===
                        AppointmentRequestType?.RESCHEDULE
                      " />
                    <img src="/assets/images/slash-bell.png" class="ml-5" *ngIf="
                        appointment?.schedule_stat === 
                        AppointmentRequestType?.REJECTED
                      " />
                  </td>
                  <td class="font-size-15 text-color" *ngIf="appointment?.patient_first_name">
                    {{ appointment?.apdate | date: dateFormat }}
                  </td>
                  <td class="font-size-15 text-color" *ngIf="appointment?.patient_first_name">
                    {{ appointment?.aptime }}
                  </td>
                  <td class="font-size-15 text-color" *ngIf="appointment?.patient_first_name">
                    {{ appointment?.patient_first_name }}
                    {{ appointment?.patient_last_name }}
                  </td>
                  <td class="font-size-15 text-color" *ngIf="appointment?.patient_first_name">
                    {{ appointment?.physician_first_name }}
                    {{ appointment?.physician_last_name }}
                  </td>
                  <td class="check" *ngIf="appointment?.patient_first_name">
                    <div class="d-flex">
                      <div class="tabledit-toolbar btn-toolbar">
                        <div class="btn-group btn-group-sm">
                          <button type="button" (click)="editRequest(appointment)"
                            class="tabledit-edit-button btn btn-sm btn-info mr-2 edit">
                            <span class="ti-pencil"></span>
                          </button>
                        </div>
                      </div>
                      <div class="tabledit-toolbar btn-toolbar">
                        <div class="btn-group btn-group-sm">
                          <button type="button" (click)="checkRequest(appointment)"
                            class="tabledit-edit-button btn btn-sm btn-success mr-2">
                            <span class="ti-check"></span>
                          </button>
                        </div>
                      </div>
                      <div class="tabledit-toolbar btn-toolbar">
                        <div class="btn-group btn-group-sm">
                          <button type="button" (click)="closeRequest(appointment)"
                            class="tabledit-edit-button btn btn-sm btn-danger mr-2">
                            <span class="ti-close"></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tbody>
                  <tr></tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row" *ngIf="Appointments?.length">
            <div class="col-md-12 mt-2">
              <div class="d-flex">
                <div class="form-group d-flex mb-0 mr-2">
                  <select class="form-control" [(ngModel)]="pagesize" id="pagesize" (change)="pageChanged()">
                    <option *ngFor="let c of pageCount" value="{{ c }}">
                      {{ c }}
                    </option>
                  </select>
                </div>
                <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [maxSize]="5" [pageSize]="pagesize"
                  [rotate]="true" [boundaryLinks]="true" (pageChange)="pageChanged()"></ngb-pagination>
                <div class="ml-2 line-h-36">
                  Total rows : {{ collectionSize }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="container-fluid" *ngIf="noAppointments">
  <div class="card m-b-30">
    <div class="card-body table-responsive">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h5 class="text-danger">NO APPOINTMENT FOUND</h5>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Edit modal -->

<ng-template #editRequestModal let-modal>
  <div class="modal-body p-4">
    <div class="form-group row">
      <div class="col-md-12">
        <div class="row mb10">
          <div class="col-md-6">
            <h5 class="innerheading font-size-15 font-weight-600">
              PATIENT INFORMATION
            </h5>
            <hr />
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-6">
                  <label class="font-color">First Name</label>
                </div>
                <div class="col-md-6">
                  <p class="text-capitalize">
                    {{ editAppoint?.patient_first_name }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-6">
                  <label class="font-color">Last Name</label>
                </div>
                <div class="col-md-6">
                  <p class="text-capitalize">
                    {{ editAppoint?.patient_last_name }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-6">
                  <label class="font-color">Date of Birth</label>
                </div>
                <div class="col-md-6">
                  <p>
                    {{ editAppoint?.dob | date: dateFormat }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-6">
                  <label class="font-color">Gender</label>
                </div>
                <div class="col-md-6">
                  <p class="text-capitalize">
                    {{ editAppoint?.gender }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-6">
                  <label class="font-color">Mobile Number</label>
                </div>
                <div class="col-md-6">
                  <p>
                    {{ editAppoint?.contact_no }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-6">
                  <label class="font-color">Email</label>
                </div>
                <div class="col-md-6">
                  <p>
                    {{ editAppoint?.patient_email_id }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-6">
                  <label class="font-color">Drug Allergy</label>
                </div>
                <div class="col-md-6">
                  <p>
                    {{ editAppoint?.drug_allergy ? "Yes" : "No" }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <h5 class="innerheading font-size-15 font-weight-600">
              APPOINTMENT INFORMATION
            </h5>
            <hr />
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-6">
                  <label class="font-color">Doctor Name</label>
                </div>
                <div class="col-md-6">
                  <p class="text-capitalize">
                    {{
                    editAppoint?.physician_title
                    ? editAppoint?.physician_title
                    : defaultdr
                    }}
                    {{ editAppoint?.physician_first_name }}
                    {{ editAppoint?.physician_last_name }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-6">
                  <label class="font-color">Consultation</label>
                </div>
                <div class="col-md-6">
                  <p class="text-capitalize">
                    {{ editAppoint?.apttype }}
                  </p>
                </div>
              </div>
            </div>
            <form [formGroup]="editAptForm">
              <div class="row">
                <div class="col-12 d-flex pl-0">
                  <div class="col-md-6">
                    <label class="font-color">Appointment Date</label>
                  </div>
                  <div class="col-md-6">
                    <p>
                      <editable>
                        <ng-template viewMode>
                          {{ editAppoint.apdate | date: dateFormat }}
                          <div *ngIf="
                              editAptForm.get('apDate').hasError('ngbDate')
                            " class="invalid-feedback">
                            Appointment Date is invalid
                          </div>
                        </ng-template>
                        <ng-template editMode>
                          <div class="d-flex">
                            <input class="form-control" placeholder="Appointment Date (DD/MM/YYYY)" name="appointDate"
                              ngbDatepicker #appoint="ngbDatepicker" data-date-inline-picker="false" id="appointDate"
                              [minDate]="currentDate" formControlName="apDate" (dateSelect)="dateTimeChangeEvent()"
                              focusable />
                            <div>
                              <button class="btn btn-outline-secondary button-height calendar rounded-0"
                                (click)="appoint.toggle()" type="button" id="AppointButton">
                                <span class="fa fa-calendar"></span>
                              </button>
                            </div>
                          </div>
                          <div *ngIf="
                              editAptForm.get('apDate').hasError('ngbDate')
                            " class="invalid-feedback">
                            Appointment Date is invalid
                          </div>
                        </ng-template>
                      </editable>
                    </p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 d-flex pl-0">
                  <div class="col-md-6">
                    <label class="font-color">Appointment Time</label>
                  </div>
                  <!-- {{editAppoint.aptime}}
                  {{aptime}} -->
                  <!-- {{'23:11:00' | convertFrom24To12Format}} -->
                  <div class="col-md-6">
                    <p>
                      <editable>
                        <ng-template viewMode>
                          <!-- {{ editAppoint.aptime }}  -->
                          {{aptime}}
                          <div *ngIf="
                              editAptForm
                                .get('apTime')
                                .hasError('invalidStartTime')
                            " class="invalid-feedback">
                            Appointment Time is invalid
                          </div>
                        </ng-template>
                        <ng-template editMode>
                          <ngb-timepicker formControlName="apTime" meridian="true"
                            (ngModelChange)="dateTimeChangeEvent()" focusable>
                          </ngb-timepicker>
                          <div *ngIf="
                              editAptForm
                                .get('apTime')
                                .hasError('invalidStartTime')
                            " class="invalid-feedback">
                            Appointment Time is invalid
                          </div>
                        </ng-template>
                      </editable>
                    </p>
                  </div>
                </div>
              </div>
            </form>
            <div class="row">
              <div class="col-md-6"></div>
              <div class="col-md-6 pl-0">
                <button class="btn btn-sm btn-primary btn-rounded" (click)="openCalendarMOdal()">
                  View Calendar
                </button>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-3">
                  <label class="font-color">Concern</label>
                </div>
                <div class="col-md-9">
                  <p>
                    {{ editAppoint?.remarks }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 mt-3">
            <p class="text-danger">
              <em>Note: Please contact the patient before changing the
                appointment time.</em>
            </p>
          </div>
        </div>

        <div class="row my-3">
          <div class="col-sm-12 text-center">
            <button type="button" class="btn btn-primary pl-5 pr-5 mr-2 btn-rounded" [disabled]="editAptForm.invalid"
              (click)="editAppointment('edit')">
              Approve
            </button>
            <button type="button" class="btn bg-color text-white pl-5 pr-5 btn-rounded" (click)="modal.dismiss()">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- check modal -->

<ng-template #checkRequestModal let-modal>
  <div class="modal-body p-5">
    <div class="row">
      <div class="col-md-3">
        <img src="/assets/images/check-health.svg" class="" />
      </div>
      <div class="col-md-9 mt-2">
        <div class="font-size-20 font-weight-400">
          Are you sure you want to accept appointment?
        </div>
        <p class="text-success mt-2 font-size-22 font-weight-500">
          This action cannot be undone!
        </p>
        <div class="mt-4 mb-4">
          <button type="button" class="btn text-white bg-color btn-rounded mr-2 pl-4 pr-4" (click)="modal.dismiss()">
            OOPS! NO. CANCEL
          </button>
          <button type="button" class="btn btn-primary mt-md-0 mt-2 mr-2 btn-rounded pl-5 pr-5"
            (click)="editAppointment('approve')">
            I AM SURE
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- close modal -->

<ng-template #closeRequestModal let-modal>
  <div class="modal-body p-5">
    <div class="row">
      <div class="col-md-3">
        <img src="/assets/images/close-health-icon.png" class="" />
      </div>
      <div class="col-md-9 mt-2">
        <div class="font-size-20 font-weight-400">
          Are you sure you want to decline appointment?
        </div>
        <p class="text-danger mt-2 font-size-22 font-weight-500">
          This action cannot be undone!
        </p>
        <div class="mt-4 mb-4">
          <button type="button" class="btn text-white bg-color btn-rounded mr-2 pl-4 pr-4" (click)="modal.dismiss()">
            OOPS! NO. CANCEL
          </button>
          <button type="button" class="btn btn-primary mt-md-0 mt-2 mr-2 btn-rounded pl-5 pr-5"
            (click)="editAppointment('cancel')">
            I AM SURE
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>